// extracted by mini-css-extract-plugin
module.exports = {"plan":"styles_plan__8JT9T","wrapper":"styles_wrapper__iFZ0C","btns":"styles_btns__4XioM"};